import BaseApplication from './base.js';
import Swiper from 'swiper';

const $ = require('jquery');
global.$ = global.jQuery = $;

import stickybits from 'stickybits';

'use strict';

export class Application extends BaseApplication {
	constructor(args = []) {
		super(args);

		this.setLog('[Extension] ', "Lodging");

		// sticky
		stickybits('#header', { useStickyClasses: true });

		this.setSlider();
	}

	callback() {
		this.showPerfomance();
		return null;
	}

	setSlider() {
        const mySwiper = new Swiper('.lodging-top', {
	        effect: 'fade',
	        speed: 400,
	        spaceBetween: 0,
	        autoplay: {
	            delay: 5000,
	        },
	        fadeEffect: {
	            crossFade: true
	        },
			pagination: {
	            el: '.swiper-pagination',
	            type: 'bullets',
	            clickable: true,
	        },
	    });
    }
};

window.Application = new Application();
